<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body liveBroadcast">
        <!-- 左侧 -->
        <div class="left-wrap"></div>
        <!-- 右侧 -->
        <div class="right-wrap" >
          <!-- 头部标题 logo -->
          <div class="logoBox">
            <img src="../../assets/images/opthonlogo.png" alt="" class="img1">
            <img src="../../assets/images/score.png" alt="" class="img2">
          </div>
          <!-- 中间队伍信息 -->
          <div class="teamsBox" style="justify-content: flex-start;">
            <div class="teamsItem" v-for="(item,index) in teamListResult" :key="index">
              <div class="teamsItem-head" style="margin-bottom: 4px;">
                <span class="teamsItem-no">G{{ item.teamNumber }}</span>
                <div class="teamsItem-name">{{ formatTeamName(item) }}</div>
              </div>
              <div class="teamsItem-list" style="justify-content: space-between; align-items: flex-start;">
                <div class="teamsItem-list-item list-item1">
                  <div class="list-item_title">CHECK POINTS</div>
                  <div class="list-item_content">8</div>
                </div>
                <div class="teamsItem-list-item list-item2" style="display: flex; flex-direction: column; align-items: center;">
                  <div class="list-item_title">
                    <div>
                      Judges
                    </div>
                    <div>
                      Appraisal
                    </div>
                  </div>
                  <div class="list-item_content lineFe">{{item.judgesScore}}</div>
                  <div class="list-item_content lineFe" v-if="item.judgesScoreall" style="text-decoration:underline;">{{item.judgesScoreall}}</div>
                </div>
                <div class="teamsItem-list-item list-item3">
                  <div class="list-item_title">Total Score</div>
                  <div class="list-item_content">{{item.totalScore}}</div>
                </div>
                <div class="teamsItem-list-item list-item4">
                  <div class="list-item_title">Vote</div>
                  <div class="list-item_content">{{item.vote}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 说明 -->
          <div class="description" style="margin-top: 45px;">*极客之分+创新之分+开源之分=评委技术总分</div>
          <!-- 底部logo -->
          <div class="bottomLogo">
            <img src="../../assets/images/Senparc.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '@/utils/drawMixin'
//
export default {
  mixins: [drawMixin],
  data() {
    return {
      loading: false,
      timing:null,
      // 队伍列表
      teamList: [],
      // 评委评分列表
      scoreList: [],
      // 投票列表
      voteList: [],
      // totals:[],
    }
  },
  components: {},
  computed: {
    // 队伍列表
    teamListResult() {
      let _reultList = [...this.teamList]
      // 分数
      if (this.scoreList && this.scoreList.length > 0) {
        this.scoreList.forEach((element) => {
          if (
            this.scoreDetail &&
            element.teamIndex === this.scoreDetail.teamIndex
          ) {
            this.scoreDetail = element
          }
          _reultList.forEach((item) => {
            item.judgesScore = item.judgesScore ? item.judgesScore : '0.0+0.0+0.0'//=
            item.judgesScoreall=item.judgesScoreall?item.judgesScoreall:'0.0'
            if (!item.totalScore) {
              let totalScore = 0
              item.matchDataCheckPoints.forEach((item2) => {
                totalScore += item2.score
              })
              item.totalScore = totalScore.toFixed(1)
            }
            if (Number(item.teamNumber) === Number(element.teamIndex)) {
              let classA = element.classA || 0
              let classB = element.classB || 0
              let classC = element.classC || 0
              let totalClass = Number(classA) + Number(classB) + Number(classC)

              console.log('item',item);
              item.judgesScore = `${classA.toFixed(1)}+${classB.toFixed(1)}+${classC.toFixed(1)}`
              item.judgesScoreall=`${totalClass.toFixed(1)}`
              // this.totals.push(`=${totalClass.toFixed(1)}`)
              let totalScore = totalClass
              // 总分
              item.matchDataCheckPoints.forEach((item2) => {
                totalScore += item2.score
              })
              item.totalScore = totalScore.toFixed(1)
            }
          })
        })
      }
      // 投票数量
      if (this.voteList && this.voteList.length) {
        this.voteList.forEach((element) => {
          _reultList.forEach((item) => {
            if (Number(item.teamNumber) === Number(element.teamIndex)) {
              item.vote = element.voteNumber
            }
          })
        })
      }
      // console.log('_reultList',_reultList);
      return _reultList
    }
  },
  filters: {},
  created() {
    // window.screen.orientation.lock('landscape-primary')
  },
  async mounted() {
    // 获取队伍列表
    await this.getList()
    // 获取评委评分
    await this.getJudgesScore()
    // 获取投票数据
    await this.getNumberVotes()

    // 数据每 10 秒刷新一次
    this.timing = setInterval(() => {
      this.getList()
      this.getJudgesScore()
      this.getNumberVotes()
    }, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    formatTeamName(item) {
      if (!item) return ''
      const name = (item.teamName || '').trim()
      if (name && !/^Group\s+\d+$/i.test(name)) {
        return name
      }
      return `Group ${item.teamNumber}`
    },
    // 获取队伍列表
    async getList() {
      await this.$axios
        .get('/api/Opathon/GetAllData/Opathon_GetAllData')
        .then((response) => {
          // console.log('获取队伍列表', response.data.data)
          this.teamList = response.data.data || []
        })
        .catch(() => {
          this.$message.error('获取队伍列表数据失败')
        })
    },
    // 获取评委评分
    async getJudgesScore() {
      await this.$axios
        .post(
          '/api/Opathon.Xncf.Judges/JudgeScoreAppService/Xncf.Judges_JudgeScoreAppService.GetAsync'
        )
        .then((response) => {
          // console.log('获取评委评分', response.data.data)
          this.scoreList = response.data.data || []
          // 队伍列表 评委技术分、总分
        })
        .catch(() => {
          this.$message.error('获取评委评分数据失败')
        })
    },
    // 获取投票数量
    async getNumberVotes() {
      await this.$axios
        .get('/api/Opathon/GetVotes/Opathon_GetVotes')
        .then((response) => {
          // console.log('获取投票数量', response.data.data)
          this.voteList = response.data.data || []
        })
        .catch(() => {
          this.$message.error('获取投票数据失败')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/index.scss';
</style>
